import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const AboutPage: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-indigo-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
          >
            About TrendBeat
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl text-gray-600 max-w-3xl mx-auto mb-4"
          >
            Empowering fashion and beauty brands with data-driven insights
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-lg text-purple-600 font-medium"
          >
            A product by <span className="font-bold">TwoKai</span> - AI and Data Science Consulting
          </motion.p>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Our Mission
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              We believe that every fashion and beauty brand deserves access to real-time, 
              actionable trend data. Our mission is to democratize access to market insights 
              that were previously only available to large corporations with massive budgets.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Our Story
            </h2>
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                <strong>TwoKai</strong> was founded in 2020 as an AI and Data Science consulting company 
                based in London. Our team of data scientists and industry experts recognized a critical 
                gap in the fashion and beauty market. While large fashion houses had access to expensive 
                trend forecasting services, smaller brands and emerging designers were left to make 
                decisions based on intuition alone.
              </p>
              <p>
                We set out to change this by building <strong>TrendBeat</strong> - a platform that combines 
                cutting-edge artificial intelligence with comprehensive social media monitoring to provide 
                real-time trend insights. Our AI models analyse millions of data points across 
                multiple platforms to identify emerging trends before they go mainstream.
              </p>
              <p>
                Today, TrendBeat serves hundreds of fashion and beauty brands worldwide, 
                from emerging designers to established retailers. We're proud to be helping 
                brands make data-driven decisions that drive growth and innovation in the industry, 
                while continuing to provide AI and data science consulting services through TwoKai.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-purple-50 rounded-2xl p-10 border border-purple-100"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Ready to collaborate?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Talk to the TrendBeat team about implementations, product questions, or bespoke insights. We respond within one business day.
            </p>
            <Link
              to="/contact"
              className="bg-purple-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors inline-block"
            >
              Contact the Team
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage; 